<template>
    <rkm-layout-body title="Lista de feriados">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-feriado-create' })"
                color="primary"
                authorize="store-cadastro-feriado"
            >
                Cadastrar feriado
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/feriado/List'

export default {
    components: { List },
}
</script>